// extracted by mini-css-extract-plugin
module.exports = {"root":"PostCommentFormClosedSitewide-root-2VX-f","message":"PostCommentFormClosedSitewide-message-TgIEg"};